export const AppUrlStrings = {
  REDIRECT_URL: "redirect",
  ADHOC_USER: "adhoc_user_id",
  TEMP_ACCESS_TOKEN: "access_token",
  TEMP_ACCESS_DOMAIN: "domain",
  USE_SAME_TAB: "same_tab",
  USE_RELOAD_TAB: "reload_tab"
};
